import { Box, Stack, Typography } from "@mui/material"
import { ThemeContext } from "../../../Shared/Theme/ThemeContext"
import { useContext } from "react";

export function AnalyticsButton({...params}){

    const { mode } = useContext(ThemeContext);

    let analyticsButtonState = params.analyticsButtonState
    let setAnalyticsButtonState = params.setAnalyticsButtonState
    let handleClick = params.handleClick

    let lightPaths = ["/icons/icons-light/icon-analytics-light-active.svg", "/icons/icons-light/icon-analytics-light-default.svg", "/icons/icons-light/icon-analytics-light-hover.svg"]
    let darkPaths = ["/icons/icons-dark/icon-analytics-dark-active.svg", "/icons/icons-dark/icon-analytics-dark-default.svg", "/icons/icons-dark/icon-analytics-dark-hover.svg"]

    let lightColors = ["#02203B", "#06569D", "#138BF6"]
    let darkColors = ["#138BF6", "#75BCFA", "#D8ECFD"]

    let onButtonPage = false
    let url = window.location.pathname
    if (url === '/analyticspage') onButtonPage = true

    const handleButtonHover = (event) => {
        event.preventDefault()
        if (onButtonPage) setAnalyticsButtonState('hover')
        else if (analyticsButtonState !== 'active') setAnalyticsButtonState('hover')
    }

    const handleButtonMouseOut = (event) => {
        event.preventDefault()
        setAnalyticsButtonState('default')
        if (onButtonPage) setAnalyticsButtonState('active')
        else if (analyticsButtonState !== 'active') setAnalyticsButtonState('default')
    }

    let imagePath = ''
    let labelColor = ''

    if (mode === 'light'){
        if (analyticsButtonState === 'active') {imagePath = lightPaths[0]; labelColor = lightColors[0]}
        else if (analyticsButtonState === 'default') {imagePath = lightPaths[1]; labelColor = lightColors[1]}
        else if (analyticsButtonState === 'hover') {imagePath = lightPaths[2]; labelColor = lightColors[2]}
    } 
    else if (mode === 'dark'){
        if (analyticsButtonState === 'active') {imagePath = darkPaths[0]; labelColor = darkColors[0]}
        else if (analyticsButtonState === 'default') {imagePath = darkPaths[1]; labelColor = darkColors[1]}
        else if (analyticsButtonState === 'hover') {imagePath = darkPaths[2]; labelColor = darkColors[2]}
    } 

    let labelFormatting = params.labelFormatting
    let labelStyling = {color: labelColor, width: '58px', height: '10px'}

    return (
        <Stack width={'71px'} height={'55px'} direction={'column'} alignItems={'center'} zIndex={100}
            onMouseOut={(event) => handleButtonMouseOut(event)} 
            onMouseOver={(event) => handleButtonHover(event)}
            onClick={(event) => handleClick(event)}>

            <Box component="img" src={imagePath} width={'36px'} height={'45px'} paddingBottom={'10px'}  id={"AnalyticsButton"}/>
            <Typography sx={[labelFormatting, labelStyling]}>Analytics</Typography>
        </Stack>
    )
}
